export const formatToSlug = (text: string): string => {
  return text
    .toLowerCase()
    .trim()
    .replace(/[\s/]+/g, "-") // eslint-disable-line no-useless-escape
    .replace(/[^a-z0-9-]/g, "")
    .replace(/-+/g, "-")
    .replace(/^-+|-+$/g, "");
};

export const splitName = (fullName: string) => {
  const parts = fullName.trim().split(" ");
  return {
    firstName: parts[0] || "",
    lastName: parts.length > 1 ? parts.slice(1).join(" ") : "",
  };
};


export const formatFrameSize = (size: string): string => {
  if (!size) return "";

  // Remove extra spaces and normalize case
  const cleaned = size.trim().toLowerCase();

  // Match common patterns like "8x12", "8 x 12", "8X12"
  const match = cleaned.match(/^(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)/);

  if (!match) return size; // return original if pattern not matched

  const width = match[1];
  const height = match[2];

  return `${width}"x${height}"`;
};


export const convertInchesToCm = (size: string): string => {
  if (!size) return "";

  // Clean up input and match patterns like "8x12", "8 x 12", "8X12"
  const cleaned = size.trim().toLowerCase();
  const match = cleaned.match(/^(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)/);

  if (!match) return size; // return original if invalid format

  const widthInch = parseFloat(match[1]);
  const heightInch = parseFloat(match[2]);

  // 1 inch = 2.54 cm
  const widthCm = (widthInch * 2.54).toFixed(2);
  const heightCm = (heightInch * 2.54).toFixed(2);

  return `${widthCm}cm x ${heightCm}cm`;
};

export type FrameOrientationClass = "square" | "landscape" | "portrait";

/** Maps frame size (e.g. 4x4, 6x4, 4x6, 4x5.6) to CSS orientation class. */
export function resolveFrameOrientationClass(
  size: string | null | undefined
): FrameOrientationClass {
  if (!size) return "square";

  const cleaned = size.trim().toLowerCase();
  const match = cleaned.match(/^(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)/);

  if (!match) return "square";

  const width = parseFloat(match[1]);
  const height = parseFloat(match[2]);

  if (width === height) return "square";
  if (width > height) return "landscape";
  return "portrait";
};

/**
 * Clear session-specific localStorage values
 * Called when starting a new session (QR scan, home navigation, station change)
 */
export const clearSessionStorage = () => {
  localStorage.removeItem("displayId");
  localStorage.removeItem("categoryId");
  localStorage.removeItem("selectedTemplateImage");
  if (process.env.NODE_ENV === 'development') {
    console.log('[clearSessionStorage] Cleared displayId, categoryId, and selectedTemplateImage from localStorage');
  }
};



export const formatStationName = (type: string) => {
  return type
    .replace(/-/g, " ")         // convert hyphens to spaces
    .trim()
    .split(/\s+/)               // split on any space(s)
    .map(
      (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    )
    .join(" ");
};

export { resolveArtDisplayName } from "./artDisplayName";